import { pathOr, values, compose, mergeDeepRight } from 'ramda';
import { UPDATE_STATE } from '../fsm/machine';

const getMeta = compose(pathOr({}, [0]), values, pathOr({}, ['payload', 'meta']));

const reducer = (state = {}, action = {}) => {
  switch (action.type) {
    case UPDATE_STATE:
      return { ...mergeDeepRight(state, getMeta(action)) };
    default:
      return state;
  }
};

export default { reducer };
